export type BatchRunState =
  | 'Queued'
  | 'Computing'
  | 'Finalizing'
  | 'Finalized';

export interface BatchProgressSnapshot {
  batchRunId: string;
  total: number;
  succeededCount: number;
  failedCount: number;
  conflictCount: number;
  cancelledCount: number;
  state: BatchRunState;
  updatedDate?: string;
}

const UI_TERMINAL_STATES: ReadonlySet<BatchRunState> = new Set<BatchRunState>([
  'Finalized',
]);

export const isBatchUiTerminal = (state?: BatchRunState): boolean => !!state && UI_TERMINAL_STATES.has(state);

export const batchProcessedCount = (snapshot: BatchProgressSnapshot): number =>
  snapshot.succeededCount + snapshot.failedCount + snapshot.conflictCount + snapshot.cancelledCount;

export interface BatchCompletionSummary {
  scrubbed: number;
  unscrubbed: number;
  total: number;
  isEvaluation: boolean;
}

export const batchCompletionSummary = (
  snapshot: BatchProgressSnapshot,
  isEvaluation = false,
): BatchCompletionSummary => {
  const scrubbed = snapshot.succeededCount + snapshot.conflictCount; // conflict = already scrubbed by a sibling batch
  return {
    scrubbed,
    unscrubbed: Math.max(0, snapshot.total - scrubbed), // total-anchored: = failed + cancelled + abandoned
    total: snapshot.total,
    isEvaluation,
  };
};

// The poll status response is the only carrier of queue position; a queued batch must be polled for it.
export const shouldPollForQueue = (state?: BatchRunState): boolean => state === 'Queued';
